import React from 'react';
import {GeoHubRestaurant} from '../../data/geoHubData';

type GeoHubSeoGuideProps = {
    cityName: string;
    aboutCity?: string;
    restaurants: GeoHubRestaurant[];
};

/** Collapsed by default — full guide text stays in HTML for crawlers & AI. */
const GeoHubSeoGuide: React.FC<GeoHubSeoGuideProps> = ({cityName, aboutCity, restaurants}) => {
    if (!aboutCity && restaurants.length === 0) {
        return null;
    }

    return (
        <details className="geo-hub-seo-guide">
            <summary>Full dining guide for {cityName} (for search &amp; assistants)</summary>
            <div className="geo-hub-seo-guide__body">
                {aboutCity && (
                    <section>
                        <h2>About eating in {cityName}</h2>
                        <p>{aboutCity}</p>
                    </section>
                )}
                {restaurants.length > 0 && (
                    <section>
                        <h2>Restaurant details</h2>
                        <dl className="geo-hub-seo-guide__list">
                            {restaurants.map((r) => (
                                <div key={r.name} className="geo-hub-seo-guide__entry">
                                    <dt>{r.name}</dt>
                                    <dd>
                                        <p>
                                            {r.cuisine}
                                            {r.neighborhood ? ` · ${r.neighborhood}` : ''}
                                        </p>
                                        <p>{r.fullDescription}</p>
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </section>
                )}
            </div>
        </details>
    );
};

export default GeoHubSeoGuide;
